import React from "react";

import redeGloboImg from "../../../../../../images/icon_channel_globo.png";
import bandImg from "../../../../../../images/icon_channel_band.svg";
import recordImg from "../../../../../../images/icon_channel_record.svg";
import sbtImg from "../../../../../../images/icon_channel_sbt.svg";

import {
  ProductTVImgRedeGloboElement,
  ProductTVImgBandElement,
  ProductTVImgRecordElement,
  ProductTVImgSbtElement,
} from "../../ProductTVValue.styles";

const ShowImagesPlanInitial = () => {
  return (
    <>
      <ProductTVImgRedeGloboElement src={redeGloboImg} alt="" />
      <ProductTVImgBandElement src={bandImg} alt="" />
      <ProductTVImgRecordElement src={recordImg} alt="" />
      <ProductTVImgSbtElement src={sbtImg} alt="" />
    </>
  );
};

export default ShowImagesPlanInitial;
